<template>
  <div>
    <el-container class="bg">
      <!-- 头部返回 -->
      <el-header class="back-header">
        <el-page-header @back="goBack" :content="content"> </el-page-header>
      </el-header>
      <!-- 表单 -->
      <el-form
        :model="fenceData"
        :rules="rules"
        ref="fenceForm"
        label-width="120px"
      >
        <!-- 头部输入 -->
        
        <!-- 主体部分 -->
        <el-container class="container">
          <!-- 侧边栏搜索 -->
          <el-aside class="aside" width="25%">
            <div class="aside-name">
              <el-form-item
              label="电子围栏名称"
              prop="name"
              size="small"
              >
                <el-input v-model.trim="fenceData.name"></el-input>
              </el-form-item>
              <el-form-item label="电子围栏半径" prop="radius" size="small">
                <el-input
                type="number"
                  v-model.number="fenceData.radius"
                  controls-position="right"
                >
                  <i slot="suffix" class="dw">米</i>
                </el-input> 
              </el-form-item>
            </div>
            

            <p class="aside-header">请选择绑定的钥匙</p>
            <el-input
              placeholder="请输入内容"
              v-model="keyName"
              class="input-with-select"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="handleKeyname"
              ></el-button>
            </el-input>
            <el-checkbox-group
              v-model="keyNameCheck"
              v-if="keyNameList.length"
              class="aside-list"
            >
              <div class="checkbox">
                <el-checkbox
                  v-for="item in keyNameList"
                  :key="item.terminalId"
                  :label="item.terminalId"
                  :disabled="item.isBound"
                  >{{ item.keyName }}</el-checkbox
                >
              </div>
            </el-checkbox-group>
            <span class="aside-list" v-else>无</span>
            <div class="aside-footer">
              <p>备注：</p>
              <p>*灰色表示钥匙已绑定电子围栏，不可再被绑定</p>
              <p>*表示钥匙状态异常</p>
            </div>
          </el-aside>
          <!-- 地图展示 -->
          <el-main class="map-main" width="75%">
            <div class="map-title">
              <p>电子围栏设置方法：*点击地图中的某一位置作为电子围栏中心点；*输入电子围栏半径，即可形成电子围栏。</p>
            </div>
            <div class="map">
              <baidu-map
                class="map"
                :center="center"
                :zoom="zoom"
                :scroll-wheel-zoom="true"
                @ready="handler"
                @click="getClickInfo"
                :min-zoom="3"
                :max-zoom="100"
                :continuous-zoom="true"
              >
                <!-- 地图类型 -->
                <!-- <bm-map-type
                  :map-types="['BMAP_HYBRID_MAP', 'BMAP_NORMAL_MAP']"
                  anchor="BMAP_ANCHOR_TOP_RIGHT'"
                ></bm-map-type> -->
                <!-- 城市 搜索 列表 -->
                <!-- <bm-city-list
                  anchor="BMAP_ANCHOR_TOP_RIGHT"
                  :offset="{ width: 100, height: 10 }"
                ></bm-city-list> -->
                <!-- <bm-geolocation
                  anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
                  :showAddressBar="true"
                  :autoLocation="true"
                ></bm-geolocation> -->
                <!-- <bm-local-search
                  :keyword="keyword"
                  :auto-viewport="true"
                  :location="location"
                  zoom="12.8"
                  style="display: none"
                ></bm-local-search> -->
                <bm-control :offset="{ width: '10px', height: '10px' }">
                  <bm-auto-complete
                    v-model="keyword"
                    :sugStyle="{ zIndex: 999999 }"
                  >
                    <el-input
                      type="text"
                      placeholder="请输入"
                      class="serachinput"
                      v-model="keyword"
                      prop="address"
                    >
                      <i
                        slot="prefix"
                        class="el-input__icon el-icon-search"
                      ></i>
                    </el-input>
                  </bm-auto-complete>
                </bm-control>
                <bm-local-search
                  :keyword="keyword"
                  :auto-viewport="true"
                  style="width: 0px; height: 0px; overflow: hidden"
                >
                </bm-local-search>
                <bm-navigation
                  anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
                ></bm-navigation>
                <!-- 标记 点 -->
                <bm-marker :position="markPoint"> </bm-marker>
                <!-- 圆圈 -->
                <bm-circle
                  :center="markPoint"
                  :radius="fenceData.radius"
                  stroke-color="#00D490"
                  :stroke-opacity="0.5"
                  :stroke-weight="2"
                  fillColor="#C5EBD2"
                ></bm-circle>
              </baidu-map>
            </div>
          </el-main>
        </el-container>
        <!-- 底部功能按钮 -->
        <el-footer class="footer">
          <el-button
            class="ec-button--plain"
            size="small"
            plain
            @click="resetForm('fenceForm')"
            >取消</el-button
          >
          <el-button
            type="primary"
            class="ec-button--primary"
            size="mini"
            @click="submitForm('fenceForm')"
            :plain="true"
            v-if="content == '新增钥匙电子围栏'"
            >创建</el-button
          >
          <el-button
            type="primary"
            class="ec-button--primary"
            size="mini"
            :plain="true"
            @click="submitForm('fenceForm')"
            v-else
            >保存</el-button
          >
        </el-footer>
      </el-form>
    </el-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "mapNum",
  data() {
    return {
      center: { lng: 116.404, lat: 39.915 },
      markPoint: { lng: "", lat: "" },
      fenceData: {
        radius: "",
        name: "",
        orgCode: "",
        longitude: "",
        latitude: "",
        fenceTerminalRel: [],
      },
      zoom: 3,
      flag: false,
      keyNameCheck: [],
      keyNameList: [],
      content: "新增钥匙电子围栏",
      keyName: "",
      location: "",
      keyword: "", //搜索框关键字
      rules: {
        name: [
          { required: true, message: "请输入电子围栏名称" },
          {
            min: 1,
            max: 20,
            message:
              "电子围栏名称由1-20个汉字、字母、数字及空格组成，不能以空格开头",
          },
        ],
        radius: [
          { required: true, message: "请输入电子围栏半径" },
          {
            type: "number",
            min: 50,
            max: 65000,
            message: "电子围栏半径范围是50~65000米，请重新输入",
          },
        ],
      },
    };
  },
  created() {
    this.initFenceData();
    this.handleKeyname();
  },
  computed: {
    ...mapState({ orgCode: "orgCode" }),
  },
  watch: {
    keyName() {
      this.handleKeyname();
    },
  },
  methods: {
    // 初始化地图参数
    handler({ BMap, map }) {
      this.zoom = 15;
      if (this.$route.query.flag == 1) {
        this.fenceData = this.$route.query.editData[0];
        this.center.lng = this.fenceData.longitude;
        this.center.lat = this.fenceData.latitude;
        this.markPoint.lng = this.fenceData.longitude;
        this.markPoint.lat = this.fenceData.latitude;
      }
    },
    // 编辑初始化
    initFenceData() {
      if (this.$route.query.flag == 1) {
        this.content = "编辑钥匙电子围栏";
        console.log(this.$route.query, "路由传参");
      }
    },
    goBack() {
      this.$router.push("/keyFence");
    },
    // 获取当前经纬度
    getClickInfo(e) {
      this.markPoint.lng = e.point.lng;
      this.markPoint.lat = e.point.lat;
      console.log("经：" + e.point.lng + "," + "纬：" + e.point.lat);
    },
    // 表单提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.markPoint.lng == "") {
            this.$message({
              message: "请设置电子围栏",
              type: "warning",
            });
            return;
          }
          this.addFence();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 表单重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.markPoint.lng = "";
      this.markPoint.lat = "";
      this.$router.push("/keyFence");
    },
    // 钥匙搜索
    async handleKeyname() {
      let _this = this;
      const { success, data } = await _this.Api.getBindKeys({
        keyName: this.keyName,
      });
      if (success) {
        this.keyNameList = data.list;
        console.log(data, "钥匙列表");
      }
    },
    //添加 编辑
    async addFence() {
      let _this = this;
      this.fenceData.orgCode = this.orgCode;
      this.fenceData.longitude = this.markPoint.lng;
      this.fenceData.latitude = this.markPoint.lat;
      this.fenceData.fenceTerminalRel = [];
      this.keyNameCheck.map((item) => [
        this.fenceData.fenceTerminalRel.push({ terminalId: item }),
      ]);
      const { success } = await _this.Api.createFence(this.fenceData);
      if (success) {
        this.$refs.fenceForm.resetFields();
        this.markPoint.lng = "";
        this.markPoint.lat = "";
        if (this.$route.query.flag == 1) {
          this.$message({
            message: "编辑成功",
            type: "success",
          });
          this.$router.push("/keyFence");
        } else {
          this.$confirm("创建成功，是否继续创建？", "提示", {
            confirmButtonText: "是",
            cancelButtonText: "否",
            type: "success",
          }).catch(() => {
            this.$router.push("/keyFence");
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.back-header {
  display: flex;
  align-items: center;
  color: #1f2329;
  font-size: 18px;
}
.bg-purple-dark {
  font-weight: 500;
  color: #1f2329;
  font-size: 18px;
  height: 50px;
  line-height: 50px;
  margin: 0px 19px 20px;
  border-bottom: 1px solid #dee0e3;
}
.bg {
  background: #fff;
}
.box {
  width: 500px;
  height: 500px;
  background: #ccc;
}
.map {
  width: 100%;
  height: 460px;
}
.container {
  border: 1px solid #ccc;
}
.aside {
  text-align: center;
  border-right: 1px solid #ccc;
}
.aside-name {
  padding: 20px;
  border-bottom: 1px solid #ccc;
}
.map-main {
  padding: 0;
}
.map-title {
  padding: 10px 0 0 15px;
  color: #696c6e;
  line-height: 10px;
  font-size: 14px;
  height: 28px;
  border-bottom: 1px solid #ccc;
}
.map-title p {
  margin-top: 0;
  margin-bottom: 1em;
}
.demo-ruleForm {
  width: 400px;
}
.aside-list {
  width: 100%;
  height: 40%;
  padding-top: 25px;
  display: block;
  text-align: center;
  font-weight: bolder;
  font-size: 14px;
  border-bottom: 1px solid #ccc;
  
}
.aside-header {
  height: 40px;
  width: 100%;
  line-height: 40px;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  color: #333;
  display: inline-block;
}
.footer {
  display: flex;
  justify-content: center;
  margin-top: 30px;
  height: 65px;
}
.aside-footer {
  text-align: left;
  height: 65px;
  padding: 10px 0 0 15px;
  color: #fc943f;
  line-height: 18px;
  font-size: 14px;
}
.serachinput {
  margin: 20px 0px 0px 20px;
}
.el-input__icon {
  margin-top: -3px;
}
.checkbox {
  margin-right: 5px;
  margin-left: 30px;
  height: 168px;
  display: flex;
  flex-direction:column;
  align-items: self-start;
  overflow: scroll;
}
.input-with-select {
  width: 250px;
}
.dw {
  font-style: normal;
  color: rgb(137, 134, 134);
  line-height: 35px;
}
</style>


// WEBPACK FOOTER //
// src/views/basicConfig/key-fence/components/addFence.vue